@if (isDesktop) {
    <bs-acca-boost-winnings [pickCount]="notification.picksCount"></bs-acca-boost-winnings>
}
@if (usLadderEnabled) {
    <div class="acca-boost-items">
        <bs-acca-boost-ladder-carousel-us
            [notification]="notification"
            [items]="notification.token.boostLadder"
            [pickCount]="notification.picksCount"
            [usLadderEnabled]="usLadderEnabled"></bs-acca-boost-ladder-carousel-us>
    </div>
} @else {
    @if (isLadderNotification(notification)) {
        <div class="acca-boost-items">
            <bs-acca-boost-ladder-carousel
                [items]="notification.token.boostLadder"
                [pickCount]="notification.picksCount"></bs-acca-boost-ladder-carousel>
        </div>
    } @else {
        <bs-acca-boost-max-reward [token]="notification.token"></bs-acca-boost-max-reward>
    }
}
